import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

import { DataTableOptions, TableService } from '@services';

import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss'],
})
export class DataTableComponent implements OnChanges {
  @Input() tableId = `dataTable_${uuidv4()}`;
  @Input() dataTableOptions: DataTableOptions;
  @Input() selectedIndex: number;

  /**
   * Emits after the underlying DataTable has completed a (re)draw. Consumers can
   * use this as a deterministic coordination point to re-apply selection state
   * once the redraw is finished, rather than guessing with a standalone timeout.
   */
  @Output() rendered = new EventEmitter<void>();

  private table: DataTables.Api;

  @ViewChild('table', { static: true }) private tableRef: ElementRef<HTMLTableElement>;

  constructor(private tableService: TableService) {
    this.tableService.defineDefaults();
  }

  ngOnChanges(changes: SimpleChanges) {
    setTimeout(() => {
      this.render();
    })
  }

  // This component's own <table>. tableId is not guaranteed unique across the hidden pages
  // Ionic keeps in the DOM, so `#${tableId}` can resolve to another page's table (CVX-6578). A template ref, not querySelector('table'):
  // with scrollX DataTables inserts a cloned header <table> ahead of this one.
  public get tableElement(): HTMLTableElement {
    return this.tableRef.nativeElement;
  }

  render() {
    this.table = this.tableService.showDataTable(this.tableElement, this.dataTableOptions);

    if (this.selectedIndex > -1) {
      (this.table.row(`:eq(${this.selectedIndex})`) as any).select();
    }

    // showDataTable() returns synchronously, but the actual (re)draw is deferred
    // (via setTimeout draw(true) for new tables / invalidate().draw() for reuse).
    // Emit from the DataTables `draw` event so the signal fires truly post-draw.
    this.table.off('draw.dataTableComponent').on('draw.dataTableComponent', () => {
      this.rendered.emit();
    });
  }

  public getTable() {
    return this.table;
  }
}
